export default "/assets/extension_empty_state-b69379d02b24f22a4eb07590f21d22122bfc1d8b9e1c2e1a77431d99621da71f.svg";